export default __webpack_public_path__ + "static/media/nailsRed.fd6991c4.jpg";